export default {
    pathParams: 'research',
    animation: 'research',
    headline: 'Исследование',
    headlineSmall: 'Исследо\u00ADвание',
    isDescComponent: false,
    description: 'Используем классические исследовательские методы и\u00A0современные инструменты неопросного анализа данных. Это\u00A0сочетание помогает отвечать на\u00A0все\u00A0ключевые вопросы, важные для\u00A0понимания контекста и\u00A0принятия бизнес-решений.',
    services: [],
};
